<template>
	<v-navigation-drawer app clipped v-model="navPaneVisible" class="overflow-hidden">
		<v-container class="pa-0 overflow-hidden" fluid fill-height justify-start>
			<v-layout column justify-start>
				<v-flex shrink align-self-center class="my-2">
					<v-btn round color="primary" dark @click.stop="createAction">{{ $t('NAV_ADD_BTN') }}</v-btn>
				</v-flex>

				<v-flex class="scroll-y">
					<v-list subheader dense>
						<v-list-tile ripple :active-class="activeClass" :to="routeAll()">
							<v-list-tile-action>
								<v-icon small>mdi-home</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{ $t('NAV_HEADER_ALL') }}</v-list-tile-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-chip label small>{{ all.total }}</v-chip>
							</v-list-tile-action>
						</v-list-tile>

						<v-list-tile ripple :active-class="activeClass" :to="routepPopular()">
							<v-list-tile-action>
								<v-icon small>mdi-finance</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{ $t('NAV_HEADER_POPULAR') }}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						
						<v-divider></v-divider>

						<v-subheader>{{ $t('NAV_HEADER_TONE') }}</v-subheader>
						<div>
							<v-list-tile v-for="i in 5" :key="i"
								ripple :active-class="activeClass" :to="routeTone(i)">
								
								<v-list-tile-content>
									<v-list-tile-title>
										<v-layout justify-space-between>
											<span>{{ $ta('GENERAL_TONE_LEVELS_SHORT', i) | capitalize }}</span>
											<v-rating
												clearable
												dense
												readonly
												small
												:value="i"
												empty-icon="mdi-human-greeting"
												full-icon="mdi-human-greeting"
												background-color="grey lighten-2"
												color="orange darken-1" />
										</v-layout>
									</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-chip label small>{{ tone(i).total }}</v-chip>
								</v-list-tile-action>
							</v-list-tile>
						</div>

						<v-divider></v-divider>

						<v-subheader>{{ $t('NAV_HEADER_RISK') }}</v-subheader>
						<div>
							<v-list-tile v-for="i in 5" :key="i"
								ripple :active-class="activeClass" :to="routeRisk(i)">
								
								<v-list-tile-content>
									<v-list-tile-title>
										<v-layout justify-space-between>
											<span>{{ $ta('GENERAL_RISK_LEVELS_SHORT', i) | capitalize }}</span>
											<v-rating
												clearable
												dense
												readonly
												small
												:value="i"
												empty-icon="mdi-alert-outline"
												full-icon="mdi-alert"
												background-color="red darken-3"
												color="red darken-3" />
										</v-layout>
									</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-chip label small>{{ risk(i).total }}</v-chip>
								</v-list-tile-action>
							</v-list-tile>
						</div>

						<v-divider></v-divider>

						<v-subheader>{{ $t('NAV_HEADER_CATEGORIES') }}</v-subheader>
						<div class="categories-wrapper">
							<v-list-tile v-for="category in categories" :key="category.name"
								ripple :active-class="activeClass" :to="routeCategory(category.name)">

								<v-list-tile-content>
									<v-list-tile-title>{{ category.name }}</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-chip label small>{{ category.count }}</v-chip>
								</v-list-tile-action>
							</v-list-tile>
						</div>
					</v-list>
				</v-flex>
			</v-layout>
		</v-container>
	</v-navigation-drawer>
</template>


<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { toRouteParams } from '@/utils/helpers';

export default {
	name: "nav-pane",
	data: () => ({
		activeClass: 'grey lighten-1 font-weight-bold',
	}),
	computed: {
		navPaneVisible: {
			get() {
				return this.$store.state.navPaneVisible;
			},
			set(visible) {
				this.$store.commit('toggleNavPane', visible);
			}
		},
		...mapState(['i18n']),
		...mapState('auth', ['filter']),
		...mapGetters('actions', {
			all: 'all',
			popular: 'popular',
			categories: 'categories',
			risk: 'byRisk',
			tone: 'byTone',
		}),
	},
	filters: {
		capitalize(str) {
			return str.charAt(0).toUpperCase() + str.slice(1);
		}
	},
	methods: {
		routeAll() {
			const filter = toRouteParams({ type: 'all' });
			return { name: 'action-list', params: { filter } }
		},
		routepPopular() {
			const filter = toRouteParams({ type: 'popular' });
			return { name: 'action-list', params: { filter } }
		},
		routeRisk(value) {
			const filter = toRouteParams({ type: 'risk', value });
			return { name: 'action-list', params: { filter } }
		},
		routeTone(value) {
			const filter = toRouteParams({ type: 'tone', value });
			return { name: 'action-list', params: { filter } }
		},
		routeCategory(value) {
			const filter = toRouteParams({ type: 'category', value });
			return { name: 'action-list', params: { filter } }
		},

		...mapActions('actions', ['createAction']),
	},
};
</script>
